// extracted by mini-css-extract-plugin
export default {"loginForm":"LoginForm_loginForm__fBxCX","label":"LoginForm_label__Bm7Qk"};